import {Button, Checkbox, Col, Divider, Form, Input, List, Modal, Row, Select, Spin, Switch, Tabs} from "antd";
import {LoadingOutlined} from "@ant-design/icons";
import ContainerComponent from "../../../helpers/components/container.component";
import PageHeaderComponent from "../../../helpers/components/page_header.component";
import React, {useEffect, useState} from "react";
import {useHistory, useParams} from "react-router-dom";
import merchantService from "../../../services/ewallet_integration/merchant.service";
import EntranceMotion from "../../../helpers/components/entrance_motion";
import TicketLayout from "../../park/ticket_v2/ticket_layout";
import TicketRuleLayout from "../../park/ticket_rule/ticket_rule_layout";
import AddOnLayout from "../../park/add_on/add_on_layout";
import TaxLayout from "../../park/tax/tax_layout";
import DateConfigCalendar from "../../park/date_config/date_config_calendar";
import InvoiceLayout from "../../park/invoice/invoice_layout";
import EntranceLayout from "../../park/entrance/entrance_layout";
import serviceHelper from "../../../helpers/functions/service.helper";
import MerchantDetail from "./detail_component/detail";
import MerchantSettlement from "./detail_component/settlement";
import MerchantUserLayout from "./detail_component/user";

const EditDetail = (default_filter) => {
    const {merchant_id} = useParams();
    const [refresh, setRefresh] = useState(false);
    const [filter, setFilter] = useState({
        tab: "info"
    })
    const [state, setState] = useState({
        loading: false,
        merchant: {},
    })
    const history = useHistory();

    const onChange = (key, checkedValues) => {
        setFilter(filter => ({...filter, [key]: checkedValues}))
        changeFilter(key, checkedValues);
    }

    // for changing filter
    const changeFilter = (key, value) => {
        let generate_filter = {...default_filter};
        generate_filter[key] = value;
        const queryString = serviceHelper?.queryString(generate_filter);
        window.history.replaceState({}, '', `${window.location.pathname}?${queryString}`);
    };


    const fetchMerchant = async () => {
        setState(state => ({...state, loading: true,}));
        const response = await merchantService.queryMerchantById(merchant_id);

        const {merchant} = response?.data;
        setRefresh(false);
        setState(state => ({...state, loading: false, merchant: merchant,}));
    }

    useEffect(() => {
        fetchMerchant();
    }, [merchant_id]);


    useEffect(() => {
        if (refresh) {
            fetchMerchant();
            setRefresh(false);
        }
    }, [refresh]);

    return (
        <>
            <Spin spinning={state?.loading} indicator={<LoadingOutlined/>}>
                <div className='mobile-padding-24' style={{textAlign: 'start'}}>
                    <div style={{marginTop: 12, marginBottom: 20,}}>
                        <ContainerComponent span={20}>
                            <div style={{marginBottom: 20}}>
                                <PageHeaderComponent title={<span style={{fontSize: 16,}}>Merchant Information</span>}
                                                     textAlign={'start'}/>
                            </div>
                            <Tabs
                                destroyInactiveTabPane
                                defaultActiveKey={filter?.tab}
                                onChange={(value) => changeFilter('tab', value)}
                                items={[
                                    {
                                        key: 'detail',
                                        label: 'Detail',
                                        children: (
                                            <>
                                                <EntranceMotion>
                                                    <MerchantDetail merchant={state?.merchant} setRefresh={setRefresh}/>
                                                </EntranceMotion>
                                            </>
                                        ),
                                    },
                                    {
                                        key: 'settlement',
                                        label: 'Settlement',
                                        children: (
                                            <>
                                                <EntranceMotion>
                                                    <MerchantSettlement merchant={state?.merchant}
                                                                        setRefresh={setRefresh} refresh={refresh}/>
                                                </EntranceMotion>
                                            </>
                                        ),
                                    },
                                    {
                                        key: 'users',
                                        label: 'Users',
                                        children: (
                                            <>
                                                <EntranceMotion>
                                                    <MerchantUserLayout merchant={state?.merchant}/>
                                                </EntranceMotion>
                                            </>
                                        ),
                                    },
                                ]}
                                className='custom-tabs'
                                animated
                            />
                        </ContainerComponent>

                        <ContainerComponent span={20}>
                            <div style={{marginTop: 20}}>
                                <Button
                                    onClick={() => history.goBack()} // go back
                                    style={{minWidth: 200}}
                                >
                                    Back to Listing
                                </Button>
                            </div>

                        </ContainerComponent>
                    </div>
                </div>
            </Spin>

        </>
    );
};

export default EditDetail;